import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SessionService } from '../services/session.service';
import { HttpParams, HttpHeaders } from '@angular/common/http';
import { ApiRequest } from './api-request';
import {
  Configuration,
  ROUTER_LINKS_FULL_PATH,
  COOKIES_CONSTANTS,
  HEADER,
  URL,
  API_TYPES,
  LOCAL_STORAGE_CONSTANTS
} from '@app/config';
import { NavigationService } from '../services/navigation.service';

@Injectable()
export class HttpRequest {
  headers: HttpHeaders;
  options: HttpHeaders;
  rootUrl = Configuration.API_ENDPOINT;
  langCode: string;
    VERSION_NO: string;

  constructor(
    private _http: HttpClient,
    private navigationService: NavigationService,
    private sessionService: SessionService,
    private apiRequest: ApiRequest,
  ) { }

  logoutUser() {
    this.headers.delete('Authorization');
    this.sessionService.removeLocalStorageItem(LOCAL_STORAGE_CONSTANTS.userInfo);
    this.sessionService.removeSessionItem(COOKIES_CONSTANTS.authToken);
    this.sessionService.clearSession();
    this.sessionService.removeSession();
    this.sessionService.deleteCookie(COOKIES_CONSTANTS.authToken);
    this.navigationService.navigate(ROUTER_LINKS_FULL_PATH.login);
  }

  /**
   * method to get the data
   *
   * @param {string} url
   * @param {HttpParams} [requestparams]
   * @param {API_TYPES} [type]
   * @param {boolean} [includeLangParam=false]
   * @returns
   * @memberof HttpRequest
   */
  public get(url: string, requestparams?: HttpParams, includeLangParam = true, type?: API_TYPES) {

    const config = this.apiRequest.getConfig(url, type, includeLangParam);

    return requestparams ? this._http.get(config[URL], { headers: config[HEADER], params: requestparams }) :
      this._http.get(config[URL], { headers: config[HEADER] });
  }

  /**
   * method to get json data from url
   *
   * @param {string} url
   * @returns
   * @memberof HttpRequest
   */
  public getJsonData(url: string) {
    return this._http.get(url + '?v=' + this.VERSION_NO);
  }

  /**
   * Used for post image or video uploading
   *
   * @param {string} url
   * @param {any} body
   * @param {HttpParams} [requestparams]
   * @param {API_TYPES} [type]
   * @returns
   * @memberof HttpRequest
   */
  // public postMultipartData(url: string, body: string, requestparams?: HttpParams, observeEvents: boolean = false, reportProgress: boolean = false) {
  //   this.setAuthorization();
  //   this.checkLanguage();
  //   url = this.handleUrl(url);
  //   var tempHeadersParam = new HttpHeaders();
  //   tempHeadersParam = tempHeadersParam.set('Authorization', this.headers.get('Authorization'));
  //   tempHeadersParam = tempHeadersParam.set('Accept-Language', this.headers.get('Accept-Language'));
  //   let options = {
  //     params: requestparams,
  //     headers: tempHeadersParam,
  //     reportProgress: reportProgress
  //   }
  //   if (observeEvents) {
  //     options['observe'] = 'events';
  //   }
  //   return this._http.post(url, body, options);
  // }

  public postMultipartData(url: string, body: string, requestparams?: HttpParams, observeEvents: boolean = false, reportProgress: boolean = false, type?: API_TYPES, ) {

    const isMultipartFileData = true;

    const config = this.apiRequest.getConfig(url, type, null, null, isMultipartFileData);
    const options = {
      params: requestparams,
      headers: config[HEADER],
      reportProgress: reportProgress
    }
    if (observeEvents) {
      options['observe'] = 'events';
    }
    return this._http.post(config[URL], body, options);
  }

  /**
   * Post method used for insert data
   *
   * @param {string} url
   * @param {any} body
   * @param {API_TYPES} [type]
   * @returns
   * @memberof HttpRequest
   */

  public post(url: string, body: any, requestparams?: HttpParams, type?: API_TYPES) {

    const config = this.apiRequest.getConfig(url, type);
    const options = { headers: config[HEADER] };
    if (requestparams) {
      options['params'] = requestparams;
    }

    if (body) {
      return this._http.post(config[URL], body, options);
    } else {
      return this._http.post(config[URL], { body }, options);
    }
  }

  /**
   * Put method used for update data
   *
   * @param {string} url
   * @param {any} body
   * @param {API_TYPES} [type]
   * @returns
   * @memberof HttpRequest
   */
  public put(url: string, body: any, type?: API_TYPES) {

    const config = this.apiRequest.getConfig(url, type);

    return this._http.put(config[URL], body, { headers: config[HEADER] });
  }

  /**
   * Delete method used for delete data
   *
   * @param {string} url
   * @param {API_TYPES} [type]
   * @returns
   * @memberof HttpRequest
   */
  public delete(url: string, type?: API_TYPES) {

    const config = this.apiRequest.getConfig(url, type);

    return this._http.delete(config[URL], { headers: config[HEADER] });
  }

  /**
   * petch method used for update data
   *
   * @param {string} url
   * @param {any} body
   * @param {API_TYPES} [type]
   * @returns 
   * @memberof HttpRequest
   */
  public patch(url: string, body: any, type?: API_TYPES) {
 
    const config = this.apiRequest.getConfig(url, type);

    return this._http.patch(config[URL], body, { headers: config[HEADER] });
  }

}



// WEBPACK FOOTER //
// ./src/app/common/http-client/http-request.ts